import React, { useEffect, useRef } from 'react';
import { TextArea } from 'wbm-inputs';
import CloseIcon from "@material-ui/icons/Close";
import { Button } from 'wbm-inputs'

type ModalProps = {
    button: any,
    charRemain: number,
    inputVal?: string,
    saveNote: Function,
    onClick: Function
}

export const AddNoteModal = ({ ...props }: ModalProps) => {
    const [inputVal, setInputVal] = React.useState(props.inputVal);
    const [charLeft, setCharLeft] = React.useState((props.charRemain || 100));
    const charRemaining = (char:string) => {
        return (props.charRemain || 100) - char.length;
    }

    const handleActionItem = () => {
        props.saveNote(inputVal);
        props.onClick();
        setCharLeft(charRemaining(inputVal));
    };

    const handleChange = e => {
        if(charRemaining(e) >= 0) {
            setInputVal(e)
            setCharLeft(charRemaining(e));
        }
    }

    const focusClose: any = useRef();
    useEffect(() => {
        if (focusClose.current) {
            focusClose.current.focus();
        }
    }, [focusClose]);

    useEffect(() => {
        if (props.inputVal && charRemaining(props.inputVal) >= 0) {
            setCharLeft(charRemaining(props.inputVal));
        }
    }, [props.inputVal]);

    return (
        <>
            <div tabIndex={0} className={"modal-overlay"}>
                <div className={"modal-note"}>
                    <div className={"closeIcon"} tabIndex={0} onKeyPress={(e) => props.onClick(e)} onClick={(e) => props.onClick(e)} ref={focusClose} >
                        <CloseIcon />
                    </div>
                    <TextArea
                        label="Note"
                        onChange={e => handleChange(e)}
                        value={inputVal}
                        id="add-note-modal"
                    />
                    <div className="char-remaining">{charLeft} Characters Remaining</div>
                    <div className="modal-note-buttons">
                        <Button className="wbm-button btn btn-link cancel-btn" onClick={(e) => props.onClick(e)}>Cancel </Button>
                        <Button className="wbm-button btn btn-primary btn-success" onClick={() => handleActionItem()}>Save </Button>
                    </div>
                </div>
            </div>
        </>
    );
}